// API service for conversation sessions following the threads pattern
import apiClient from './apiClient';

class SessionsAPI {

  // POST /conversation/sessions/
  async createSession(sessionData) {
    return apiClient.makeAuthenticatedRequest('/conversation/sessions/', {
      method: 'POST',
      body: JSON.stringify(sessionData),
    });
  }

  // GET /conversation/sessions/?user_id=&limit=&offset=
  async getSessionsByUser(userId, limit = 100, offset = 0) {
    const params = new URLSearchParams({
      user_id: String(userId),
      limit: String(limit),
      offset: String(offset),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/?${params}`, {
      method: 'GET',
    });
  }

  // GET /conversation/sessions/{session_id}
  async getSessionById(sessionId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/${encodeURIComponent(sessionId)}`, {
      method: 'GET',
    });
  }

  // GET /conversation/sessions/hash/{hash_id}
  async getSessionByHashId(hashId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/hash/${encodeURIComponent(hashId)}`, {
      method: 'GET',
    });
  }

  // PUT /conversation/sessions/{session_id}
  async updateSession(sessionId, updateData) {
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/${encodeURIComponent(sessionId)}`, {
      method: 'PUT',
      body: JSON.stringify(updateData),
    });
  }

  // DELETE /conversation/sessions/{session_id}
  async deleteSession(sessionId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/${encodeURIComponent(sessionId)}`, {
      method: 'DELETE',
    });
  }

  // GET /conversation/sessions/{session_id}/with-messages
  async getSessionWithMessages(sessionId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/${encodeURIComponent(sessionId)}/with-messages`, {
      method: 'GET',
    });
  }

  // GET /conversation/sessions/thread/{thread_id}?limit=&offset=
  async getSessionsByThread(threadId, limit = 100, offset = 0) {
    const params = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/thread/${encodeURIComponent(threadId)}?${params}`, {
      method: 'GET',
    });
  }

  // GET /conversation/sessions/user/{user_id}/recent?days=&limit=
  async getRecentSessions(userId, days = 7, limit = 10) {
    const params = new URLSearchParams({
      days: String(days),
      limit: String(limit),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/user/${encodeURIComponent(userId)}/recent?${params}`, {
      method: 'GET',
    });
  }

  // GET /conversation/sessions/user/{user_id}/search?label=
  async searchSessionsByLabel(userId, label) {
    const params = new URLSearchParams({
      label: String(label),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/user/${encodeURIComponent(userId)}/search?${params}`, {
      method: 'GET',
    });
  }

  // GET /conversation/sessions/user/{user_id}/count
  async getSessionCount(userId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/user/${encodeURIComponent(userId)}/count`, {
      method: 'GET',
    });
  }

  // DELETE /conversation/sessions/user/{user_id}/all
  async deleteAllUserSessions(userId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/user/${encodeURIComponent(userId)}/all`, {
      method: 'DELETE',
    });
  }

  // PATCH /conversation/sessions/{session_id}/label
  async updateSessionLabel(sessionId, label) {
    return apiClient.makeAuthenticatedRequest(`/conversation/sessions/${encodeURIComponent(sessionId)}/label`, {
      method: 'PATCH',
      body: JSON.stringify({ label: String(label) }),
    });
  }
}

export default new SessionsAPI();


